<template>
  <hic-list-page title="数据字典管理" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="请输入名称或编码">
    <template slot="buttons">
      <el-button v-if="user.tenantId == 1 && !this.selectedDict" class="left-pad" type="danger" @click="create" size="small" icon="el-icon-plus" title="字典类型请勿随意添加，如果代码中没有用到，添加也没有意义！">字典类型</el-button>
      <span v-if="isGlobal && !IamMaster" type="warning" :closable="false" center class="warning">全局字典，禁止编辑！</span>
      <el-button v-if="isMine && selectedDict" class="left-pad" type="primary" @click="create" size="small" icon="el-icon-plus">
        {{ selectedDict.code | dictText("DictType") }}
      </el-button>
      <el-button v-if="!isGlobal && isMaster && !isMine" class="left-pad" type="warning" @click="copy" size="small">
        <i class="el-icon-copy"></i>
        拷贝平台字典
      </el-button>
    </template>
    <template slot="search">
      <el-select v-if="sysIsMasterData" v-model="sysCode" style="width: 7rem" class="left-pad" size="small" @change="sysChange" clearable>
        <el-option v-for="s in mySys" :key="s.id" :value="s.code" :label="s.name" />
      </el-select>
      <hic-dict-selector v-if="dict.DictType" class="condition-wide" @change="dictSelected" dict-type="DictType" :sys="sysCode" style="width: 7rem" />
    </template>

    <el-table-column label="名称" prop="text" width="250" key="text" sortable="custom">
      <template slot-scope="{ row }">
        <b>{{ row.text }}</b>
      </template>
    </el-table-column>
    <el-table-column v-if="isMine" label="操作" width="200" align="center" key="action">
      <template slot-scope="{ row }">
        <el-button type="primary" icon="el-icon-edit" title="编辑" size="mini" @click="edit(row)" circle plain :disabled="row.global && user.tenantId != 1" />
        <el-button type="warning" icon="el-icon-plus" title="添加下级字典" size="mini" @click="createChild(row)" circle plain v-if="isSelfParent()" :disabled="row.global && user.tenantId != 1" />
        <!-- <el-button type="danger" icon="el-icon-close" title="删除" size="mini" @click="edit(scope.row)" circle /> -->
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" width="100" align="left" key="code" sortable="custom" />
    <el-table-column label="助记码" prop="shortCode" width="100" align="left" key="shortCode" sortable="custom" />
    <el-table-column v-if="isOtherParent()" label="分类" width="150" :filters="dict[selectedDict.parentType]" :filter-multiple="false" column-key="parentCode" key="parentCode" sortable>
      <template slot-scope="scope">
        {{ scope.row.parentCode | dictText(selectedDict.parentType) }}
      </template>
    </el-table-column>
    <el-table-column label="排序" prop="seqNo" width="80" align="center" key="seqNo" sortable="custom"></el-table-column>
    <!-- <el-table-column label="平台字典" prop="ifMaster" width="80" key="ifMaster" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.ifMaster" type="danger" size="mini" effect="plain">是</el-tag>
          </template>
        </el-table-column> -->
    <el-table-column label="只读" prop="global" width="60" key="global" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="isGlobal || row.global" type="danger" size="mini" effect="plain">是</el-tag>
      </template>
    </el-table-column>

    <slot />

    <el-table-column label="备注" prop="memo" show-overflow-tooltip key="memo" />
    <el-table-column label="扩展" prop="extra" show-overflow-tooltip key="extra" />

    <el-footer style="height: 2.5rem">
      <el-pagination layout="total, sizes, prev, pager, next, jumper, slot" @size-change="page" @current-change="page" :current-page.sync="condition.pageIndexOnView" :page-size.sync="condition.pageSize" :total="entities.total">
        <el-tag type="danger" v-if="isGlobal" effect="plain" hit size="small" class="left-pad">全局字典</el-tag>
        <el-tag type="warning" v-else-if="isMaster" effect="plain" hit size="small" class="left-pad">平台字典</el-tag>
        <el-tag type="success" v-else effect="plain" hit size="small" class="left-pad">我的字典</el-tag>
      </el-pagination>
    </el-footer>
    <dict-editor v-model="entity" :visible.sync="meta.showEditor" @ok="entityUpdated" />
  </hic-list-page>
</template>

<script>
  import { api } from "sw-hic";
  import { mapGetters } from "sw-hic";
  export default {
    name: "dict-list-page",
    components: {
      "dict-editor": () => import("./editor"),
    },
    data() {
      return {
        meta: {
          loading: false,
          showEditor: false,
        },
        sysCode: null,
        condition: {
          sort: "seqNo",
          asc: true,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        searchLoading: false,
        entities: {},
        selectedDict: null,
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "user"]),
      isGlobal() {
        return this?.selectedDict?.global ?? false;
      },
      // 当前字典是租主的字典
      isMaster() {
        if (this.entities.items && this.entities.items.length) {
          return this.entities.items[0].ifMaster;
        }
        return false;
      },
      isMine() {
        if (this.isMaster || this.isGlobal) {
          return this.IamMaster;
        }
        return true;
      },
      IamMaster() {
        return this.user.tenantId == 1;
      },
      mySys() {
        if (this.IamMaster) {
          return this.dict.Sys;
        } else {
          return this.dict.MySys;
        }
      },
      sysIsMasterData() {
        return "masterdata" == this?.$cfg.sys.code;
      },
    },

    created() {
      api.Dict.query({ type: "DictType" }).then((res) => {
        this.$store.commit("dict", { type: "DictType", items: res.items });
      });
      if (!this.sysIsMasterData) {
        this.sysCode = this?.$cfg.sys.code;
      }
    },
    mounted() {
      this.page();
    },
    methods: {
      page() {
        if (!this.selectedDict) {
          this.entities = {};
          return;
        }
        let _this = this;
        this.meta.loading = true;
        api.Dict.queryByType(this.selectedDict.code, this.condition).then((res) => {
          if (_this.isSelfParent()) {
            // 如果自关联，则使用树形结构。如果他关联 作为分类，使用列表结构。
            let treeItems = _this.findChildren(res.items);
            res.items = treeItems;
          }
          _this.entities = res;
          _this.meta.loading = false;
        });
      },
      sysChange() {
        this.selectedDict = null;
        this.dictSelected(null);
      },
      dictSelected(code, dict) {
        this.selectedDict = dict;
        if (!code) {
          this.entities.items = [];
          this.entities.pageIndexOnView = 1;
          this.entities.total = 0;
          return;
        }

        this.$store.dispatch("loadDicts", [code]);
        if (dict.parentType) {
          this.$store.dispatch("loadDicts", [dict.parentType]);
        }
        this.page();
      },
      findChildren(srcItems, code) {
        let children = srcItems.filter((item) => {
          return item.parentCode == code || (!code && !item.parentCode);
        });

        children.forEach((child) => {
          let chs = this.findChildren(srcItems, child.code);
          if (chs.length) {
            child.children = chs;
          }
        });
        return children;
      },
      create() {
        let curr = this.selectedDict;
        if (!curr) {
          curr = { code: "DictType" };
        }
        let entity = {
          type: curr.code,
        };
        if (curr.parentType) {
          entity.parentType = curr.parentType;
        }
        this.$set(this, "entity", entity);
        this.meta.showEditor = true;
      },
      edit(row) {
        this.$set(this, "entity", JSON.parse(JSON.stringify(row)));
        this.meta.showEditor = true;
      },
      entityUpdated(value) {
        this.$store.dispatch("unLoadDicts", value.type);
        this.$store.dispatch("loadDicts", value.type);
        this.page();
      },
      createChild(parent) {
        let entity = {
          type: parent.type,
          parentCode: parent.code,
        };
        this.$set(this, "entity", entity);
        this.meta.showEditor = true;
      },
      sortChanged(col) {
        if (!col.order) {
          this.condition.sort = "id";
          this.condition.asc = false;
        } else {
          this.condition.sort = col.prop;
          this.condition.asc = col.order == "ascending";
        }
        this.page();
      },
      filterChanged(options) {
        Object.assign(this.condition, options);
        this.page();
      },
      isSelfParent() {
        let dict = this.selectedDict;
        return dict.parentType && dict.parentType == dict.code;
      },
      isOtherParent() {
        let dict = this.selectedDict;
        return dict?.parentType && dict.parentType != dict.code;
      },
      copy() {
        api.Dict.copy(this.selectedDict.code).then((res) => {
          this.page();
        });
      },
    },
  };
</script>
